module.exports = __webpack_public_path__ + "static/media/twitter.eab7b7fb.svg";